<div id="myearth">
    <div id="glow"></div>
</div>